(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'AssociateApplication',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		$form.find('#copy-address').change(function copyAddress() {
			var $self = $(this);

			if ($self.is(':checked')) {
				$('#associateapplication-credit_card_address1').val($('#associateapplication-address1').val());
				$('#associateapplication-credit_card_address2').val($('#associateapplication-address2').val());
				$('#associateapplication-credit_card_city').val($('#associateapplication-city').val());
				$('#associateapplication-credit_card_state_id').val($('#associateapplication-state_id').val());
				$('#associateapplication-credit_card_zip').val($('#associateapplication-zip').val());
			}
		});
	};
}(jQuery, window.Adzuki || {}));
